export default "__VITE_ASSET__0c3f8774__"